import type {ReactNode} from 'react';

import {SiteFooter} from './site-footer.js';
import {SiteHeader} from './site-header.js';

/** Props accepted by {@link PageShell}. */
export interface PageShellProps {
  children: ReactNode;
}

/**
 * Page frame shared by every route.
 *
 * @param props The page content.
 * @returns The rendered shell.
 */
export function PageShell({children}: PageShellProps): React.JSX.Element {
  return (
    <div className="flex min-h-dvh flex-col">
      <SiteHeader />
      <main className="flex-1">{children}</main>
      <SiteFooter />
    </div>
  );
}
